export const stakeArray = [0.25, 0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
//export const stakeArray = ["0.25", "0.5", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]